module.exports = __webpack_public_path__ + "img/kentang-goreng.99660ddf.jpg";